import React, { ReactElement } from 'react';
import cn from 'classnames';
import styles from './Hover.module.scss';
import { OutsideClick } from '../HOCS/OutsideClick/OutsideClick';

interface HoverI {
  className?: string;
  children?: ReactElement | ReactElement[];
  isOpen?: boolean;
  onClose?: (event: MouseEvent) => void;
}
export const Hover = React.forwardRef<HTMLDivElement, HoverI>(
  ({ children, className, isOpen, onClose }, ref) => {
    console.log(isOpen);

    const CloseWhenClickOutSide = OutsideClick(() => (
      <div ref={ref} className={cn(styles.root, isOpen && styles.open)}>
        <div className={styles['hover-container']}>{children}</div>
      </div>
    ));
    return (
      <CloseWhenClickOutSide onClickOutside={onClose} className={className} />
    );
  }
);

Hover.displayName = 'HoverElement';
